import React, { useState } from 'react';
import styled from 'styled-components';
import Modal from '../components/advance/Modal';
import Button from '../components/core/EPL_Button_Think';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';

const IframeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 90vw;

  .pdf-viewer {
    width: 80vw;
    height: 80vh;
    border: none;
  }

  .modal-header {
    align-items: center;
    background-color: #eeeeee;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    padding: 4px;
  }

  .zoom-button {
    padding: 0px 2px;
  }
`;

const PdfModal = ({ isOpen, onClose, url, showCloseButton, onOk }) => {
    const zoomPluginInstance = zoomPlugin();
    const pageNavigationPluginInstance = pageNavigationPlugin();
    const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;
    const { CurrentPageLabel } = pageNavigationPluginInstance;
    const [isLastPage, setIsLastPage] = useState(false);
    const [error, setError] = useState(null);

    const handleError = (error) => {
        setError(error.message || "An error occurred while loading the PDF.");
        return error.message;
    }

    return (
        <Modal
            open={isOpen}
            showCloseButton={showCloseButton}
            closeOnClickOutside={false}
            onClose={onClose}
        >
            <IframeWrapper>
                <div className="modal-header">
                    <div className="zoom-button">
                        <ZoomOutButton />
                    </div>
                    <div className="zoom-button">
                        <ZoomPopover />
                    </div>
                    <div className="zoom-button">
                        <ZoomInButton />
                    </div>
                    <div className="zoom-button">
                        <CurrentPageLabel>
                            {(props) => {
                                const { currentPage, numberOfPages } = props;
                                if (currentPage + 1 === numberOfPages) {
                                    setIsLastPage(true);
                                } else {
                                    setIsLastPage(false);
                                }
                                return <span>{`${currentPage + 1} of ${numberOfPages}`}</span>;
                            }}
                        </CurrentPageLabel>
                    </div>
                </div>
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                    <div className="pdf-viewer">
                        <Viewer fileUrl={url} defaultScale={0} plugins={[zoomPluginInstance, pageNavigationPluginInstance]} renderError={handleError} />
                    </div>
                </Worker>
                <Button
                    text={"OK"}
                    onClick={onOk}
                    disabled={!isLastPage && !error}
                />
            </IframeWrapper>
        </Modal>
    );
};

export default PdfModal;
